import { ref } from 'vue';

export const useModal = () => {
  const isOpen = ref<boolean>(false);

  const openModal = (): void => {
    isOpen.value = true;
  };

  const closeModal = (): void => {
    isOpen.value = false;
  };

  return {
    isOpen,
    openModal,
    closeModal,
  };
};
